module.exports = __webpack_public_path__ + "static/media/koletralogo.ded4b1f5.png";